import { DatePickerValue } from '@factorialco/f0-react'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'

export const stringDateToDatePicker = (
  date: string | null | undefined
): DatePickerValue | undefined => {
  if (!date) {
    return undefined
  }
  const parsedDate = stringToDate(date, 'backend_datetime')
  if (!parsedDate.isValid()) {
    return undefined
  }
  const normalizedDate = parsedDate.toDate()
  return {
    granularity: 'day' as const,
    value: {
      from: normalizedDate,
      to: normalizedDate
    }
  }
}

export const datePickerDateToString = (date: DatePickerValue | undefined): string | undefined => {
  const selectedDate = date?.value?.from
  if (!selectedDate) {
    return undefined
  }
  return i18nDateToString(selectedDate, 'backend_datetime')
}
